import { AxiosError } from 'axios';
import { routes } from '@/constants';
import localStorage from '../utils/localStorage';

export function apiErrorHandler(error: AxiosError) {
  if (error.response?.status === 401) {
    localStorage.setItem('user', null);

    window.location.replace(routes.signIn);
  }

  return Promise.reject(error);
}
